exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wrapper {\n  background-color: #165684; }\n  .wrapper .login-img {\n    display: block;\n    margin: 0 auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/pages/resetPassword/resetPassword.component.scss
// module id = 1115
// module chunks = 7